<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.87402 9V6C8.87402 3.79086 7.08316 2 4.87402 2C0.5 2 1.00004 6.5 1.00004 8" stroke="#292929" stroke-width="2" stroke-linecap="round"/>
    <path d="M5 10H19V19C19 20.1046 18.1046 21 17 21H7C5.89543 21 5 20.1046 5 19V10Z" stroke="#292929" stroke-width="2" stroke-linejoin="round"/>
    <rect x="14.5" y="15.5" width="0.01" height="0.01" stroke="#292929" stroke-width="3" stroke-linejoin="round"/>
  </svg>
</template>